module.exports = __webpack_public_path__ + "static/media/atencao.5f53cb56.svg";